export const COLLABORATOR_LIST_COLUMNS = [
  { field: 'nome', headerName: 'Colaborador', align: 'left' },
  { field: 'cpf', headerName: 'CPF', align: 'left' },
  { field: 'numeroCartao', headerName: 'N⁰ cartão', align: 'center' },
  { field: 'acoes', headerName: '', align: 'center' }
]
